// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "packing-form table {\n  width: 100%;\n}\npacking-form th:first-of-type {\n  text-align: left;\n}\npacking-form th {\n  text-align: center;\n}\npacking-form tr.group td {\n  font-weight: bolder;\n}\npacking-form td:first-of-type {\n  text-align: left;\n}\npacking-form td {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
